// extracted by mini-css-extract-plugin
export default {"root":"PFYI05","button":"Opqnjh","title":"QqbV7l","paragraph":"hB5nu5"};